const isBundleProduct = (product) => {
    const productTypes = product.Result.product_types || [];
    return productTypes.indexOf(2048) !== -1;
};
export default isBundleProduct;
//# sourceMappingURL=is-bundle-product.js.map